export default __webpack_public_path__ + "static/media/menu.de299b43.svg";